import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Avatar,
  Spinner,
} from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import useData from '../../../data/useData';
import { CustomToast } from '../../../components/toast/CustomToast';
import { mutateFunction, useMutation } from '../../../libs/apis';
import moment from 'moment';
import { StarIcon } from '@chakra-ui/icons';

const Users = ({ viewUser, searchTerm }) => {
  const { data, isLoading } = useData(`experts?search=${searchTerm}`);
  const [experts, setexperts] = useState([]);
  const [index, setIndex] = useState(-1);
  const { mutate, isLoading: Load } = useMutation(mutateFunction);
  const { addToast } = CustomToast();
  const [isSorted, setIsSorted] = useState(false);
  const [sortType, setSortType] = useState('date');

  useEffect(() => {
    if (data?.data) {
      setexperts(data.data.experts);
    }
  }, [data]);

  const navigate = useNavigate();

  const triggerResetPassword = (e, user) => {
    e.stopPropagation();
    e.preventDefault();

    let data = {
      email: user?.email,
    };

    setIndex(user.id);
    mutate(
      { key: 'forgot-password', method: 'post', data },
      {
        onSuccess(res) {
          setIndex(-1);

          // showCheckEmail();
          // onToggleCheckEmail();
          addToast({
            message: 'Sucesss, email reset process sent to user.',
            type: 'info',
          });
        },
      },
    );
  };

  const compareStr = (a, b) => {
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else {
      return 0;
    }
  };

  const compareDates = (a, b) => {
    if (moment(b).isBefore(a, 'day')) {
      return 1;
    } else if (moment(a).isBefore(b, 'day')) {
      return -1;
    } else {
      return 0;
    }
  };

  const accountTypes = {
    active: 0,
    disabled: 1,
    blocked: 2,
  };

  const sortFunctions = {
    status: (a, b) => {
      return isSorted
        ? accountTypes[b?.status] - accountTypes[a?.status]
        : accountTypes[a?.status] - accountTypes[b?.status];
    },
    profile: (a, b) => {
      return isSorted
        ? compareStr(a?.first_name, b?.first_name)
        : compareStr(b?.first_name, a?.first_name);
    },
    email: (a, b) => {
      return isSorted
        ? compareStr(a?.email, b?.email)
        : compareStr(b?.email, a?.email);
    },
    date: (a, b) => {
      return isSorted
        ? compareDates(a?.date_added, b?.date_added)
        : compareDates(b?.date_added, a?.date_added);
    },
    mode: (a, b) => {
      return isSorted
        ? compareStr(
            a?.expert_price?.status || 'Draft',
            b?.expert_price?.status || 'Draft',
          )
        : compareStr(
            b?.expert_price?.status || 'Draft',
            a?.expert_price?.status || 'Draft',
          );
    },
  };

  const sortFunction = (a, b) => {
    return sortType && sortFunctions[sortType] && sortFunctions[sortType](a, b);
  };

  const toggleSort = (type) => {
    type === sortType ? setIsSorted((prev) => !prev) : setIsSorted(true);
    setSortType(type);
  };

  return (
    <>
      <Box mt="50px" className="w-full  flex items-end justify-end">
        <Button
          color="white"
          borderRadius="4px"
          bg="#134A70"
          h="40px"
          _hover={{ bg: '#134A70', color: '#FFFFFF' }}
          onClick={() => navigate('/useraddexpert')}
        >
          + Add New
        </Button>
      </Box>
      <Box maxHeight={'100vh'} className={`hide-scroll`} overflow={'auto'}>
        <TableContainer mb="20px" mt="20px" borderRadius="10px 10px 0px 0px">
          <Table variant="simple" size="sm" fontSize="12px">
            <Thead bgColor="rgba(19, 74, 112, 0.05)">
              <Tr fontSize="2px">
                <Th
                  className="cursor-pointer"
                  onClick={() => toggleSort('profile')}
                >
                  Profile
                </Th>
                <Th
                  className="cursor-pointer"
                  onClick={() => toggleSort('email')}
                >
                  Email
                </Th>
                <Th>Phone no</Th>
                <Th>Country</Th>
                <Th>Position</Th>
                <Th
                  className="cursor-pointer"
                  onClick={() => toggleSort('date')}
                >
                  Date Added
                </Th>
                <Th
                  className="cursor-pointer"
                  onClick={() => toggleSort('status')}
                >
                  Status
                </Th>
                <Th
                  className="cursor-pointer"
                  onClick={() => toggleSort('mode')}
                >
                  Mode
                </Th>
                <Th>Trigger Password Reset</Th>
                <Th>Last Seen</Th>
              </Tr>
            </Thead>
            {!isLoading ? (
              <Tbody>
                {experts?.sort(sortFunction).map((items) => {
                  return (
                    <Tr
                      style={{ padding: '2rem 2rem' }}
                      boxShadow="md"
                      borderRadius="10px"
                      borderColor="#000"
                      _hover={{
                        borderWidth: '2px',
                        borderColor: 'brand.primary',
                        borderRadius: '10px',
                      }}
                      bg={() => {
                        let mode = items?.expert_price?.status || 'Draft';
                        return mode.toLowerCase() === 'draft'
                          ? '#faebeb'
                          : '#eefaeb';
                      }}
                      cursor={'pointer'}
                      onClick={() => viewUser(items.user_id)}
                    >
                      <Td
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                          height: '100%',
                        }}
                      >
                        <div className='relative flex flex-col gap-[1px]'>
                          <Avatar
                            name={`${items?.first_name} ${items?.last_name}`}
                            src={items.profile_image}
                            alt=""
                            size="sm"
                            mr={2}
                          />

                          <div className="flex flex-row  bottom-0 z-10 gap-[1px] ml-1 items-center">
                            <StarIcon
                              h={2}
                              w={2}
                              color={items?.rating > 0 ? 'yellow.400' : 'initial'}
                            />
                            <StarIcon
                              h={2}
                              w={2}
                              color={items?.rating > 1 ? 'yellow.400' : 'initial'}
                            />
                            <StarIcon
                              h={2}
                              w={2}
                              color={items?.rating > 2 ? 'yellow.400' : 'initial'}
                            />
                          </div>
                        </div>
                        <Text>
                          {items?.first_name} {items?.last_name}
                        </Text>
                      </Td>
                      <Td className="td" pl="15px">
                        {items.email}
                      </Td>
                      <Td className="td">{items?.phone_number}</Td>
                      <Td className="td">
                        {items?.expert_price?.location?.title}
                      </Td>
                      <Td className="td">{items?.position}</Td>
                      <Td className="td">
                        {new Date(items.date_added).toDateString()}
                      </Td>
                      <Td className="td capitalize">{items?.status}</Td>
                      <Td className="td capitalize">
                        {items?.expert_price?.status || 'Draft'}
                      </Td>
                      <Th
                        onClick={(e) => triggerResetPassword(e, items)}
                        className="td"
                      >
                        {items.user_id == index ? (
                          <Spinner />
                        ) : (
                          <>
                            <Button
                              _hover={{
                                borderWidth: '2px',
                                borderColor: 'brand.primary',
                                borderRadius: '10px',
                              }}
                            >
                              Trigger
                            </Button>
                          </>
                        )}
                      </Th>
                      <Td className="td">
                        {moment(items?.last_seen || items?.updated_at).format(
                          `MMM D, YYYY`,
                        )}
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            ) : (
              <Flex w="100%">
                <Spinner />
              </Flex>
            )}
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default Users;
